import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import Button from '../../Atoms/Button';
const StyledContainer = styled.div `
  display: inline-flex;
`;
const StyledButton = styled(Button) `
  &:not(:last-child) {
    margin-right: 0.666666667rem;
  }
`;
const getButtonFromName = (buttons, buttonName) => (buttons.find((button) => button.name === buttonName));
const renderButtons = (buttons, onClick, activeButton, buttonClassName, activeButtonClassName) => buttons.map((button) => {
    var _a;
    return (React.createElement(StyledButton, { key: button.name, className: classnames(buttonClassName, {
            [activeButtonClassName]: ((_a = activeButton) === null || _a === void 0 ? void 0 : _a.name) === button.name,
        }), label: button.label, onClick: () => onClick(button) }));
});
const ButtonGroup = ({ className, buttonClassName, activeButtonClassName, buttons, defaultActiveButton = '', onClick = () => { }, }) => {
    const [activeButton, setActiveButton] = useState();
    useEffect(() => {
        setActiveButton(getButtonFromName(buttons, defaultActiveButton));
    }, [defaultActiveButton]);
    const onButtonClick = useCallback((selectedButton) => {
        if (!activeButton || activeButton.name !== selectedButton.name) {
            setActiveButton(selectedButton);
            onClick(selectedButton);
        }
    }, [activeButton, onClick]);
    return (React.createElement(StyledContainer, { className: className }, renderButtons(buttons, onButtonClick, activeButton, buttonClassName, activeButtonClassName)));
};
export default ButtonGroup;
